//TODO IMPORTANT this file must be refactored

var registrationContainer = document.querySelector("#anmeldung");
var registrationIframe = document.querySelector(".registration-iframe");
if (registrationContainer) {
  var OffsetToRegistraionContainer = registrationContainer.getBoundingClientRect().top ?? 0;
}

if (registrationIframe) {
  window.addEventListener("message", function (event) {
    if (
      event.origin.includes("anmeldung.landrover-live.de") ||
      event.origin.includes("landrover-live-anmeldung.mokom01projects.test") &&
      event.data.type == "sizeRequest"
    ) {
      //console.log(event);
      if (Number(event.data.data)) {
        registrationIframe.height = event.data.data + "px";
      }
    }
  
    // check if iframe has error
    if (event.data.type === 'formSubmitted' && event.data.data.errors > 0) {
      var totalOffset = OffsetToRegistraionContainer;

      if (event.data.data.firstErrorOffset < 350) {
        totalOffset = OffsetToRegistraionContainer - event.data.data.firstErrorOffset;
      } else if (event.data.data.firstErrorOffset < 350 || event.data.data.firstErrorOffset > 788) {
        totalOffset = OffsetToRegistraionContainer + (event.data.data.firstErrorOffset / 4);

      }else {
        totalOffset = OffsetToRegistraionContainer + (event.data.data.firstErrorOffset / 6);
      }

      $("html, body").animate(
        { scrollTop: totalOffset }, //3800
        500
      );
    }

    // form success
    if (event.data.type === 'formSuccess' && event.data.data ) {
      $("html, body").animate(
        { scrollTop: $("#anmeldung").offset().top - 100 },
        500
      );
    }
  });

  registrationIframe.addEventListener("load", function () {
    setInterval(() => {
      registrationIframe.contentWindow.postMessage("sizeRequest", "*");
    }, 1000);
  });
}

// Call scrollToSectionWithOffset function when the page is loaded
scrollToSectionWithOffset();

function scrollToSectionWithOffset() {
  var url = window.location.href;
  var urlParams = new URLSearchParams(window.location.search);
  var hash = urlParams.get("hash");
  if (!hash) {
    var hashIndex = url.indexOf("#");
    if (hashIndex !== -1) {
      hash = url.substring(hashIndex + 1);
    }
  }
  if (hash) {
    if (hash == "anmeldung" || hash == "Anmeldung") {
      $(".event-details #anmeldung .registration-btn").addClass("d-none");
      $(".event-details .registration-iframe").removeClass("d-none");
    }

    var $targetSection = $("#" + hash);
    if ($targetSection.length) {
      var anchorNavSection = document.querySelector(".anchor-nav-section");
      var topbar = document.querySelector(".topbar");
      var menubar = document.querySelector(".menubar");
      var topbarHeight = topbar ? topbar.offsetHeight : 0;
      var menubarHeight = menubar ? menubar.offsetHeight : 0;
      var anchorNavSectionHeight = anchorNavSection ? anchorNavSection.offsetHeight : 0;
      var adjustedOffset =
        topbarHeight + menubarHeight + anchorNavSectionHeight + 50;
      // $("html, body").animate(
      //   {
      //     scrollTop: $targetSection.offset().top - (adjustedOffset - 50),
      //   },
      //   10
      // );
      //
      // Scrolling function from jQuery to native JS
      document.querySelector("body, html").scrollTo({
        top: $targetSection.offset().top - (adjustedOffset - 50),
        left: 0,
        behavior: "smooth",
      });
    }
  }
}

const eventForm = document.getElementById("filter_event");
const eventBtn = document.getElementsByClassName("load-events")[0];
const eventList = document.querySelector(".event-blocks");

const loadMoreEvents = (e) => {
  e.preventDefault();
  let url = e.target.getAttribute("data-href");
  let body = [];
  if (e.target.classList.contains("load-filtered-event")) {
    url = eventForm.action;
    document.getElementById("current-event-page").value =
      e.target.getAttribute("data-page");
    document.getElementById("last-event").value =
      e.target.getAttribute("data-image");
    body = new URLSearchParams(new FormData(eventForm));
  }
  fetchEvents(url, body, false);
};

if (eventBtn != null) {
  eventBtn.addEventListener("click", loadMoreEvents, false);
  eventBtn.addEventListener("click", function () {
    $(".event-blocks-search").addClass("loading");
  });
}

if (eventForm) {
  const url = eventForm.action;
  eventForm.addEventListener("submit", (event) => {
    event.preventDefault();
    $(".event-blocks-search").addClass("loading");
    eventList.innerHTML = "";
    document.getElementById("current-event-page").value = 1;
    fetchEvents(url, new URLSearchParams(new FormData(eventForm)), true);
  });
}

function fetchEvents(url, body, filter) {
  const paginationClass = document.querySelector(".load-events");
  if (paginationClass) {
    var paginationClassEvents = paginationClass.closest(
      ".pagination-load-wrap"
    );
    paginationClassEvents.innerHTML = "";
  }

  fetch(url, { method: "POST", body })
    .then((resp) => resp.text())
    .then((html) => {

      //if(isJson(html)) {

      /*redirect = JSON.parse(html);
      if(redirect.redirectUrl){
        
        location.href = redirect.redirectUrl;
      }*/
      
    //}
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");

      const eventRecords = doc.querySelector(".event-blocks").innerHTML;
      if (filter === true) {
        eventList.innerHTML = eventRecords;

        const eventRecordsWrapper = document.createElement("div");
        eventRecordsWrapper.innerHTML = eventRecords;
        if (!eventRecordsWrapper.querySelectorAll(".event-block").length > 0) {
          $(".loadmore-button").css("display", "none");
        } else {
          $(".loadmore-button").css("display", "flex");
        }
      } else {
        var tempDiv = document.createElement("div");
        tempDiv.innerHTML = eventRecords;
        var eventRecordsRowElement = tempDiv.querySelector(".row");
        eventList.querySelectorAll(".row")[0].innerHTML +=
          eventRecordsRowElement.innerHTML;
      }
      $(".event-blocks-search").removeClass("loading");
      var brand = $('#autoSizingSelect3').find(":selected").val();
      var defaultLogo;
      switch (brand) {
        case "1":
          defaultLogo = 'logo_Range.svg';
          break;
        case "2":
          defaultLogo = 'logo_Defender.svg';
          break;
        case "3":
          defaultLogo = 'logo_Discovery.svg';
          break;
        default:
          defaultLogo = '';
          break;
      }

      if(defaultLogo){
        var fullPath = '/_static_assets\/'+defaultLogo;
        var htmllogo = "<img src='"+fullPath+"'  height='10' width='140' title='Logo' loading='lazy'/>";
        var foundbrand = location.search.split("/brand");
       // if(foundbrand["0"] == ""){
          $(".ajaxlogo").html(htmllogo);
          $(".ajaxlogo").css("display", "flex");
       

          $(".menubar .navbar-brand.brand-logo").hide();
          $(".navbar-brand.logoAjax").addClass("d-flex");
        
      } else {
        $(".navbar-brand.brand-logo").css("display", "flex");
        $(".navbar-brand").removeClass("d-flex");
        $(".navbar-brand .global").hide();
        $(".logoAjax, .ajaxlogo").hide();
        $(".navbar-brand.brand-logo").addClass("land-rover");
      }
      const paginateWrapper = doc.querySelector(".load-events");
      if (paginateWrapper) {
        const paginate = paginateWrapper.closest(
          ".pagination-load-wrap"
        ).innerHTML;
        if (paginationClassEvents) {
          paginationClassEvents.innerHTML = paginate;
          var evtLoadMoreBtn =
            paginationClassEvents.querySelector(".load-events");
        } else {
          $(".pagination-load-wrap").html(paginate);
          var evtLoadMoreBtn = $(".pagination-load-wrap .load-events")[0];
        }
        evtLoadMoreBtn.addEventListener("click", loadMoreEvents, false);
      }else{
        $('.event-blocks-search .event-blocks').css('min-height', 'auto');
      }
    })
    .catch((error) => {
      console.log("Error " + error.message);
    });
}

const speakerFilterForm = document.getElementById("filter_speaker");
const loadMoreSpeakersBtn = document.getElementsByClassName("load-speakers")[0];
const speakersList = document.querySelector(".speakers-blocks");

const loadMoreSpeakers = (e) => {
  e.preventDefault();
  let url = e.target.getAttribute("data-href");
  let body = [];

  fetchSpeakers(url, body, false);
};

if (loadMoreSpeakersBtn != null) {
  loadMoreSpeakersBtn.addEventListener("click", loadMoreSpeakers, false);
}
if (speakerFilterForm) {
  const url = speakerFilterForm.action;
  speakerFilterForm.addEventListener("submit", (event) => {
    event.preventDefault();
    speakersList.innerHTML = "";
    document.getElementById("current-speaker-page").value = 1;
    fetchSpeakers(
      url,
      new URLSearchParams(new FormData(speakerFilterForm)),
      false
    );
  });
}

function fetchSpeakers(url, body, filter) {
  const paginationClass = document.querySelector(".load-speakers");
  if (paginationClass) {
    var paginationClassSpeakers = paginationClass.closest(
      ".pagination-load-wrap"
    );
    paginationClassSpeakers.innerHTML = "";
  }

  fetch(url, { method: "POST", body })
    .then((resp) => resp.text())
    .then((html) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");

      const speakersRecords = doc.querySelector(".speakers-blocks").innerHTML;
      speakersList.innerHTML += speakersRecords;

      const paginateWrapper = doc.querySelector(".load-speakers");
      if (paginateWrapper) {
        const paginate = paginateWrapper.closest(
          ".pagination-load-wrap"
        ).innerHTML;
        paginationClassSpeakers = document.querySelector(
          ".pagination-load-wrap"
        );
        paginationClassSpeakers.innerHTML = paginate;
        const evtBtn = paginationClassSpeakers.querySelector(".load-speakers");
        evtBtn.addEventListener("click", loadMoreSpeakers, false);
      }
    })
    .catch((error) => {
      console.log("Error " + error.message);
    });
}

const loadMorePartnersBtn = document.getElementsByClassName("load-partners")[0];
const partnersList = document.querySelector(".logo-blocks .row");

const loadMorePartners = (e) => {
  e.preventDefault();
  let url = e.target.getAttribute("data-href");
  let body = [];

  fetchPartners(url, body, false);
};

if (loadMorePartnersBtn != null) {
  loadMorePartnersBtn.addEventListener("click", loadMorePartners, false);
}

function fetchPartners(url, body) {
  const paginationClass = document.querySelector(".load-partners");
  if (paginationClass) {
    var paginationClassPartners = paginationClass.closest(
      ".pagination-load-wrap"
    );
    paginationClassPartners.innerHTML = "";
  }

  fetch(url, { method: "POST", body })
    .then((resp) => resp.text())
    .then((html) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");

      const partnerRecords = doc.querySelector(".logo-blocks .row").innerHTML;
      partnersList.innerHTML += partnerRecords;

      const paginateWrapper = doc.querySelector(".load-partners");
      if (paginateWrapper) {
        const paginate = paginateWrapper.closest(
          ".pagination-load-wrap"
        ).innerHTML;
        paginationClassPartners = document.querySelector(
          ".pagination-load-wrap"
        );
        paginationClassPartners.innerHTML = paginate;
        const evtBtn = paginationClassPartners.querySelector(".load-partners");
        evtBtn.addEventListener("click", loadMorePartners, false);
      }
    })
    .catch((error) => {
      console.log("Error " + error.message);
    });
}

$(".event-details .stage-events-content .registration-btn").click(function (e) {
  e.preventDefault();
  var anchorNavSection = document.querySelector(".anchor-nav-section");
  var topbar = document.querySelector(".topbar");
  var menubar = document.querySelector(".menubar");
  var topbarHeight = topbar ? topbar.offsetHeight : 0;
  var menubarHeight = menubar.offsetHeight;
  var anchorNavSectionHeight = anchorNavSection.offsetHeight;
  var adjustedOffset =
    topbarHeight + menubarHeight + anchorNavSectionHeight + 50;

  $("html, body").animate(
    {
      scrollTop: $("#anmeldung").offset().top - (adjustedOffset - 100),
    },
    500
  );
});

$(document).ready(function () {
  $(".nav.nav-pills .nav-link").removeClass("active");
    
  const navLinks = document.querySelectorAll('.nav.nav-pills .nav-link');
  navLinks.forEach(link => link.classList.remove('active'));
  const secondNavLink = navLinks[1];
  
  if (secondNavLink) {
      secondNavLink.classList.add('active');
  }
  initEventMap();
  geocoder = new google.maps.Geocoder();

  if (
    window.location.href.includes("speaker/detail") &&
    $("#speakerCount").children(".section").length % 2 === 0
  ) {
    $("#speakerSlider").addClass("bg-white");
  }

  // FAQ Section - open & Close Button
  $(".open-tabs").click(function () {
    if ($(".open-tabs").hasClass("closed")) {
      $(".accordion-collapse").addClass("show");
      $(".accordion-button").removeClass("collapsed");
      $(".open-tabs").removeClass("closed");
      $(".open-tabs").text("Alle schließen");
    } else {
      $(".accordion-collapse").removeClass("show");
      $(".accordion-button").addClass("collapsed");
      $(".open-tabs").addClass("closed");
      $(".open-tabs").text("Alle öffnen");
    }
  });

  $(".accordion-button").click(function () {
    if (
      $(".accordion-collapse").not(".show").length ===
      $(".accordion-collapse").length
    ) {
      $(".open-tabs").text("Alle öffnen");
      $(".open-tabs").addClass("closed");
    }
  });

  $(".accept-external").click(function () {
    $(".external-container").addClass("d-none");
    $(".youtube-video").removeClass("d-none");
  });

  $(".decline-external").click(function () {
    $(".external-container").addClass("d-none");
    $(".external-container-declined").removeClass("d-none");
  });

  $(".external-container");

  $("select").each(function () {
    // Apply Select2 plugin
    $(this).select2();
  });

  // Current Location feature
  $(".current-location").click(function (e) {
    e.preventDefault();
    navigator.geolocation.getCurrentPosition(showPosition, showError);
  });

  // Enter triggers search
  $("#inlineFormInput").focus(function () {
    $(".current-location").addClass("d-flex");
    $(".current-location").removeClass("d-none");
    $(document).keypress(function (event) {
      if (event.key === "Enter") {
        event.preventDefault();
        $("#searchButton").click();
        $("#inlineFormInput").blur();
      }
    });
  });

  $("#inlineFormInput").blur(function () {
    setTimeout(function () {
      $(".current-location").addClass("d-none");
      $(".current-location").removeClass("d-flex");
    }, 100);
  });

  window.addEventListener("scroll", function () {
    var anchorNavSection = document.querySelector(".anchor-nav-section");
    var anchorNavWrapper = document.querySelector(".anchor-nav-wrapper");
    var topbar = document.querySelector(".topbar");
    var menubar = document.querySelector(".menubar");
    var topbarHeight = topbar ? topbar.offsetHeight : 0;
    var menubarHeight = menubar.offsetHeight;
    var scrollPosition = window.scrollY;
    var registerBtn = $('.nav-pills a[href="#anmeldung"]')[0];
    if (anchorNavSection) {
      // Calculate the adjusted offset
      var adjustedOffset =
        anchorNavSection.offsetTop - topbarHeight - menubarHeight;
      if (anchorNavSection.classList.contains("subject")) {
        var adjustedOffset = anchorNavSection.offsetTop;
      }

      if (scrollPosition > adjustedOffset) {
        anchorNavWrapper.classList.add("scroll");
        anchorNavWrapper.classList.remove("no-scroll");
        if (registerBtn) {
          registerBtn.classList.remove("d-none");
          registerBtn.classList.add("btn-form");
          registerBtn.classList.add("btn");
        }

        $("#signUpScroll").text("Jetzt anmelden")
      } else {
        anchorNavWrapper.classList.add("no-scroll");
        anchorNavWrapper.classList.remove("scroll");

        if (registerBtn) {
          registerBtn.classList.remove("btn-form");
          registerBtn.classList.remove("btn");
        }
        $("#signUpScroll").text("Anmeldung")
      }
    }
  });

  if ($(".event-details").length > 0 || $(".scrollspy").length > 0) {
    // Cache the navigation links
    var $navigationLinks = $(".nav-pills a").not('[href="#top"]');

    var sections = [];
    $navigationLinks.each(function () {
      var $link = $(this);
      var $target = $($link.attr("href"));
      if ($target.length) {
        sections.push({
          link: $link,
          target: $target,
          offset: $target.offset().top,
        });
      }
    });

    function updateNavigation() {
      var scrollTop = $(window).scrollTop();
      var activeSectionIndex = null;
      var anchorNavSection = document.querySelector(".anchor-nav-section");
      var topbar = document.querySelector(".topbar");
      var menubar = document.querySelector(".menubar");
      var topbarHeight = topbar ? topbar.offsetHeight : 0;
      var menubarHeight = menubar.offsetHeight;
      var anchorNavSectionHeight = anchorNavSection.offsetHeight;
      var adjustedOffset =
        topbarHeight + menubarHeight + anchorNavSectionHeight + 50;

      for (var i = 0; i < sections.length; i++) {
        if (scrollTop >= sections[i].offset - adjustedOffset) {
          activeSectionIndex = i;
        }
      }
      if (activeSectionIndex !== null) {
        $navigationLinks.removeClass("active");
        $navigationLinks.blur();
        sections[activeSectionIndex].link.addClass("active");
      }
    }

    $(window).on("scroll", updateNavigation);
  }

  // Anchor link click event listener
  document
    .querySelectorAll('#scrollby-detail a[href^="#"]')
    .forEach((anchor) => {
      anchor.addEventListener("click", function (e) {
        e.preventDefault(); // Prevent default behavior
        var targetId = this.getAttribute("href").substring(1); // Get target ID
        var targetElement = document.getElementById(targetId); // Get target element
        var topbar = document.querySelector(".topbar");
        var menubar = document.querySelector(".menubar");

        var topbarHeight = topbar ? topbar.offsetHeight : 0;
        var menubarHeight = menubar.offsetHeight;

        if (targetElement) {
          var scrollPosition =
            targetElement.offsetTop - (topbarHeight + menubarHeight); // Calculate scroll position
          targetElement.style.paddingTop = topbarHeight + menubarHeight;

          window.scrollTo({
            top: scrollPosition,
            behavior: "smooth", // Smooth scrolling
          });
        }
      });
    });

  function initEventMap() {
    const address = $(".event-details .event-full-address").text();
    const eventMapDiv = document.getElementById("event-map-div");
    const geocoder = new google.maps.Geocoder();

    if (eventMapDiv) {
      geocoder.geocode({ address: address }, function (results, status) {
        if (status === "OK") {
          const myLatLng = results[0].geometry.location;

          const map = new google.maps.Map(eventMapDiv, {
            zoom: 12,
            center: myLatLng,
            styles: [
              {
                elementType: "geometry",
                stylers: [{ color: "#dfdfdf" }],
              },
              {
                elementType: "labels.icon",
                stylers: [{ visibility: "off" }],
              },
              {
                featureType: "landscape",
                elementType: "all",
                stylers: [{ color: "#f2f2f2" }],
              },
            ],
            disableDefaultUI: true,
          });

          const marker = new google.maps.Marker({
            position: myLatLng,
            map: map,
            icon: {
              url:
                "data:image/svg+xml;utf8," +
                encodeURIComponent(
                  '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="32" viewBox="0 0 12 16"><g id="Gruppe_524" data-name="Gruppe 524" transform="translate(-16 -13)"><circle id="Ellipse_6" data-name="Ellipse 6" cx="2" cy="2" r="2" transform="translate(20 17)" fill="#0c121c"/><path id="Pfad_91" data-name="Pfad 91" d="M22,13a6,6,0,0,0-3.6,10.8L20,25a3.33,3.33,0,0,1,1.336,2.669v.667a.667.667,0,1,0,1.333,0v-.667A3.33,3.33,0,0,1,24,25L25.6,23.8A6,6,0,0,0,22,13Zm2.4,10-2.056,1.234a.665.665,0,0,1-.686,0L19.6,23a4.667,4.667,0,1,1,4.8,0Z" transform="translate(0 0)" fill="#0c121c"/></g></svg>'
                ),
            },
          });

          const mapsUrl = `https://www.google.com/maps/dir/?api=1&destination=${address}`;
          $(".googleMapsLink").attr("href", mapsUrl);
        } else {
          $("#standort .content-img").hide();
          $("#standort p").hide();
          console.error(
            "Geocode was not successful for the following reason: " + status
          );
        }
      });
    }
  }

  async function showPosition(position) {
    var latlng = {
      lat: position.coords.latitude,
      lng: position.coords.longitude,
    };
    geocoder.geocode({ location: latlng }, function (results, status) {
      if (status === "OK") {
        let city = "";
        for (let i = 0; i < results[0].address_components.length; i++) {
          for (
            let j = 0;
            j < results[0].address_components[i].types.length;
            j++
          ) {
            if (results[0].address_components[i].types[j] === "locality") {
              city = results[0].address_components[i].long_name;
              break;
            }
          }
          if (city !== "") {
            break;
          }
        }
        $("#inlineFormInput").val(city);
      }
    });
  }

  function showError(error) {
    $("#failedLocationModal").modal("show");
    console.error(error);
  }

  $(window).on("resize", function () {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", vh + "px");
    setPlaybuttonInitPosition();
  });

  setPlaybuttonPosition();
  setPlaybuttonInitPosition();

  $(
    ".slider-hero, .slider-teaser-col4, .slider-teaser-col3, .slider-default, .slider-teaser-col5",
  ).on("init breakpoint", function (event, slick) {
    addSliderPlayButton(this, slick);
    setPlaybuttonInitPosition();
  });

  $(".slider-hero").slick({
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: false,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: false,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          arrows: false,
        },
      },
    ],
  });

  $(".known-from-slider").slick({
    dots: false,
    infinite: true,
    speed: 1000,
    slidesToShow: 4,
    slidesToScroll: 1,
    adaptiveHeight: false,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 4000,
    pauseOnHover: false,
    pauseOnFocus: false,
    slickPause: false,
    responsive: [
      {
        breakpoint: 1279,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 989,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });

  $(".slider-default").slick({
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: false,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          arrows: false,
        },
      },
    ],
  });

  var slideCount = null;
  var clickedPostIndex = null;

  $(".post-link").on("click", function () {
    clickedPostIndex = $(this).data("post-index");
  });

  $("#facebook-model").on("shown.bs.modal", function (e) {
    $(".slider-modal").slick({
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true,
      arrows: true,
      autoplay: false,
      autoplaySpeed: 5000,
      pauseOnHover: false,
      initialSlide: clickedPostIndex,
      responsive: [
        {
          breakpoint: 769,
          settings: {
            arrows: false,
          },
        },
      ],
    });
    $("#facebook-model").removeClass("d-none");
    $("#fb-slider").removeClass("d-none");
  });

  $("#id-cookie-notice a").attr("target", "_blank");

  $(".cookie-settings").click(function () {
    klaro.show();
  })


  $("#facebook-model").on("hide.bs.modal", function (e) {
    $("#facebook-model").addClass("d-none");
    $(".slider-modal").slick("unslick");
  });

  $(".slider-modal").on("init", function (event, slick) {
    slideCount = slick.slideCount;
    $(".slide-count-wrap")
      .find(".active")
      .text(slick.currentSlide + 1);
    $(".slide-count-wrap").find(".sum").text(slideCount);
  });

  $(".slider-modal").on("afterChange", function (event, slick, currentSlide) {
    $(".slide-count-wrap")
      .find(".active")
      .text(currentSlide + 1);
  });

  $(".previous-trigger").click(function () {
    $(".slider-modal").slick("slickPrev");
  });

  $(".next-trigger").click(function (event, slick) {
    $(".slider-modal").slick("slickNext");
  });

  $(".slider-teaser-col5").slick({
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 5,
    slidesToScroll: 5,
    adaptiveHeight: true,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: false,
    responsive: [
      {
        breakpoint: 551,
        settings: {
          arrows: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          adaptiveHeight: true,
        },
      },
      {
        breakpoint: 769,
        settings: {
          arrows: true,
          slidesToShow: 2,
          slidesToScroll: 2,

          adaptiveHeight: true,
        },
      },
      {
        breakpoint: 1281,
        settings: {
          arrows: true,
          slidesToShow: 3,
          slidesToScroll: 3,
          adaptiveHeight: true,
        },
      },
      {
        breakpoint: 1537,
        settings: {
          arrows: true,
          slidesToShow: 4,
          slidesToScroll: 4,
          adaptiveHeight: true,
        },
      },
    ],
  });

  $(".slider-teaser-col4").slick({
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    adaptiveHeight: true,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: false,
    responsive: [
      {
        breakpoint: 551,
        settings: {
          arrows: true,
          dots: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          adaptiveHeight: true,
        },
      },
      {
        breakpoint: 769,
        settings: {
          arrows: true,
          slidesToShow: 2,
          slidesToScroll: 2,

          adaptiveHeight: true,
        },
      },
      {
        breakpoint: 1281,
        settings: {
          arrows: true,
          slidesToShow: 3,
          slidesToScroll: 3,
          adaptiveHeight: true,
        },
      },
    ],
  });

  $(".slider-teaser-col3").slick({
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    adaptiveHeight: false,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: false,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          arrows: true,
          slidesToShow: 1,
          adaptiveHeight: true,
        },
      },
      {
        breakpoint: 1281,
        settings: {
          arrows: true,
          slidesToShow: 2,
          adaptiveHeight: true,
        },
      },
    ],
  });

  $(".slider-navigation .js-go-to-slide").on("click", function () {
    var slide = $(this).data("slide");
    var $slider = $(this)
      .closest(".slider-container")
      .find(".slider-with-navigation");
    goToSlide($slider, slide);
    toggleSlideMenu($(this).closest(".slider-navigation").find("ul"));
  });
  $(".slider-with-navigation").on(
    "beforeChange",
    function (event, slick, currentSlide, nextSlide) {
      var $slide = $(this).find(".slick-slide.slick-current .slide");

      updateSliderNavigation($(this), nextSlide);
    }
  );

  function addSliderPlayButton(element, slick) {
    var $slider = $(element);
    var controls =
      '<button aria-label="pause" class="pagination-pause"> <span class="pause"> <svg class="progress-ring" width="42" height="42"> <circle class="circle" stroke="pink" stroke-width="2" fill="transparent" r="20" cx="21" cy="21" /> </svg> <span class="icon icon-pause" ><svg aria-hidden="true" width="10px" height="16px" viewBox="0 0 10 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" > <g stroke="none" stroke-width="1"> <g transform="translate(-473.000000, -299.000000)" fill-rule="nonzero" > <g transform="translate(473.000000, 299.000000)"> <polygon points="0 0 2 0 2 16 0 16"></polygon> <polygon points="8 0 10 0 10 16 8 16"></polygon> </g> </g> </g></svg ></span> </span> </button> <button class="pagination-play"> <span class="play"> <svg class="progress-ring" width="42" height="42"> <circle class="circle" stroke="white" stroke-width="2" fill="transparent" r="20" cx="21" cy="21" /> </svg> <span class="icon icon-play" ><svg aria-hidden="true" width="14px" height="20px" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 14 20" xml:space="preserve" > <path d="M-0.1,0v20l14-10L-0.1,0z M1.6,3.2l9.5,6.7l-9.5,6.8C1.6,16.7,1.6,3.2,1.6,3.2z" ></path></svg ></span> </span> </button>';
    var sliderSpeed = slick.options.autoplaySpeed + "ms";
    var sliderSpeedWithTransition =
      slick.options.autoplaySpeed + slick.options.speed + "ms";
    var animationClass = "animate";

    $slider.find(".slick-dots").wrap('<div class="slider-controls"></div>');
    $slider.find(".slider-controls").prepend(controls);

    var $playbutton = $slider.find(".pagination-play");
    var $pauseButton = $slider.find(".pagination-pause");

    // Hide play button on start
    $playbutton.hide();

    // Start autoplay and toggle play/pause controls
    $playbutton.on("click", function () {
      var currentSlideIndex = $slider.slick("slickCurrentSlide");
      if (
        $(slick.$slides.get(currentSlideIndex))
          .find(".slide")
          .find("fullsize-video")
      ) {
        let $videoSlider = $(slick.$slides.get(currentSlideIndex)).find(
          ".slide"
        );
        $videoSlider.find("video").trigger("play");
        $pauseButton.find(".circle").css("animationDuration", sliderSpeed);
        $pauseButton.addClass(animationClass);
      } else {
        $pauseButton.find(".circle").css("animationDuration", sliderSpeed);
        $pauseButton.addClass(animationClass);
      }

      $pauseButton.show();
      $slider.slick("slickPlay");
      $playbutton.hide();
    });

    // Pause autoplay and toggle play/pause controls
    $pauseButton.on("click", function () {
      var currentSlideIndex = $slider.slick("slickCurrentSlide");
      if (
        $(slick.$slides.get(currentSlideIndex))
          .find(".slide")
          .find("fullsize-video")
      ) {
        let $videoSlider = $(slick.$slides.get(currentSlideIndex)).find(
          ".slide"
        );
        $videoSlider.find("video").trigger("pause");
      }

      $slider.slick("slickPause");
      $pauseButton.hide().removeClass(animationClass);
      $playbutton.show();
    });

    // check if first slide is video then stop slick autoplay and start video
    setTimeout(function () {
      var currentSlideIndex = $slider.slick("slickCurrentSlide");
      if ($($slider.get(currentSlideIndex)).find(".slide.fullsize-video")[0]) {
        let $videoSlider = $($slider.get(0)).find(".slide.fullsize-video")[0];
        $($videoSlider).find("video").trigger("play");
        $slider.slick("slickPause");
      } else {
        // Adjust animation-duration to autoplay speed and start animation on pause button
        $pauseButton.find(".circle").css("animationDuration", sliderSpeed);
        $pauseButton.addClass(animationClass);
      }
    }, 50);

    // Restart pause button animation before change
    $slider.on(
      "beforeChange",
      function (event, slick, currentSlide, nextSlide) {
        if (
          $(slick.$slides.get(currentSlide))
            .find(".slide")
            .hasClass("fullsize-video")
        ) {
          let $videoSlider = $(slick.$slides.get(currentSlide)).find(".slide");
          $videoSlider.find("video").trigger("pause");
        }

        if (
          $(slick.$slides.get(nextSlide))
            .find(".slide")
            .hasClass("fullsize-video")
        ) {
          let $videoSlider = $(slick.$slides.get(nextSlide)).find(".slide");
          $videoSlider.find("video").get(0).currentTime = 0;
        }

        $pauseButton.removeClass("animate");

        setTimeout(function () {
          if (
            !$(slick.$slides.get(nextSlide))
              .find(".slide")
              .hasClass("fullsize-video")
          ) {
            $pauseButton
              .find(".circle")
              .css("animationDuration", sliderSpeedWithTransition);
            $pauseButton.addClass(animationClass);
          } else {
            $pauseButton.removeClass("animate");
          }
        }, 50);
      }
    );

    $slider.on("afterChange", function (event, slick, currentSlide, nextSlide) {
      if (
        $(slick.$slides.get(currentSlide))
          .find(".slide")
          .hasClass("fullsize-video")
      ) {
        let $videoSlider = $(slick.$slides.get(currentSlide)).find(".slide");
        $videoSlider.find("video").trigger("play");
        $slider.slick("slickPause");
      }
    });

    // Mobile fix for default behaviour that pauses autoplay on touch
    $slider.find(".slick-list").on("touchstart", function (e) {
      $pauseButton.trigger("click");
    });
    $slider.find(".slick-list").on("touchend", function () {
      $playbutton.trigger("click");
    });

    $("video").on("ended", function () {
      $slider.slick("slickPlay");
      $slider.slick("slickNext");
    });
  }

  /**
   * Toggle slide menu
   */
  function toggleSlideMenu($menu) {
    if ($menu.prev(".js-toggle-slide-select").is(":visible")) {
      $menu.slideToggle();
    }
  }

  /**
   * Go to slide
   */
  function goToSlide(slider, slide) {
    slider.slick("slickGoTo", slide);
    updateSliderNavigation(slider, slide);
  }

  /**
   * Update slider navigation
   */
  function updateSliderNavigation(slider, slide) {
    var $sliderNavigation = slider
      .closest(".slider-container")
      .find(".slider-navigation");
    $sliderNavigation.find("li").removeClass("is-active");
    $sliderNavigation.find("li").eq(slide).addClass("is-active");

    var activeValue = $sliderNavigation.find("li.is-active span").text();
    $sliderNavigation.find(".slide-select").text(activeValue);
  }

  // Video Stage Position Playbutton
  function setPlaybuttonPosition() {
    var stage = $(".stage-slider-hero");
    var slide = stage.find(".slide");
    var image = slide.find(".img-wrapper");

    var controls = stage.find(".slider-controls");
    if (image != null && image.length != 0) {
      var height = image.height();
      if ($(window).width() < 1024) {
        controls.css("position", "absolute");
        controls.css("top", height - 60 - 42 + "px");
        controls.css("padding-left", 20 + "px");
      } else {
        controls.css("top", "auto");
        controls.css("padding-left", 0 + "px");
      }
    }
  }

  // Video Stage Position Playbutton
  function setPlaybuttonInitPosition() {
    var stage = $(".stage-slider-hero");
    var slide = stage.find(".slide");
    var image = slide.find(".img-wrapper img");

    var controls = stage.find(".slider-controls");
    var height = image.height();

    controls.css("top", height - 60 + "px");

    var stageDefault = $(".slider-default");
    var slideDefault = stageDefault.find(".slide");
    var imageDefault = slideDefault.find(".img-wrapper img");

    var controlsDefault = stageDefault.find(".slider-controls");
    var heightDefault = imageDefault.height();

    controlsDefault.css("top", heightDefault - 100 + "px");
  }

  $(".facebook-model").on("click", function () {
    $("#facebook-model").modal("show");
  });

  // Copy a href value
  var cobyBtn = document.getElementById("copy-sharing-link");
  if (cobyBtn) {
    cobyBtn.addEventListener("click", function (event) {
      event.preventDefault();

      var href = this.href;

      var tempInput = document.createElement("input");
      tempInput.setAttribute("value", href);
      document.body.appendChild(tempInput);

      tempInput.select();
      tempInput.setSelectionRange(0, 99999);
      document.execCommand("copy");

      // Remove the temporary input
      document.body.removeChild(tempInput);

      $("#copy-sharing-link .icon-copy").removeClass("icon-copy").addClass("icon-check");
    });
  }

  // Show Event Registration iFrame
  $(".event-details .registration-btn").click(function (e) {
    $(".event-details #anmeldung .registration-btn").addClass("d-none");
    $(".event-details .registration-iframe").removeClass("d-none");
  });
  $('#scrollby-detail li.scroll-visible').each(function(){
    $(this).find("a").removeClass("active");
    var link = location.search;
    if(link) {
      var spl = link.split("&selectNav=");
      if(spl.length > 1){
        var nav = spl[1].split("&");
        var titlevalue = $(this).find("a").attr("title");
        if(titlevalue == nav[0]){
        $("li a[title="+nav[0]+"]").addClass("active"); 
            var target = "#"+nav[0];
            $('html, body').animate({
                    scrollTop: $(target).offset().top-250
                }, 50);
        }
      }
    }


    });
    
});

function isJson(data) {
  if (typeof data === 'object' && data !== null) {
      return true; // Already a JSON-like object/array
  }

  if (typeof data === 'string') {
      try {
          JSON.parse(data);
          return true; // String is valid JSON
      } catch {
          return false; // String is not valid JSON
      }
  }

  return false; // Neither an object/array nor a valid JSON string
}

    